import { CircularProgress } from "@mui/material";
import { Flex, Modal, QRCode } from "antd";
import { FunctionComponent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAssignTo } from "../../shared/api/assignationRequest";
import { getStudentCode } from "../../shared/api/edificeRequest";
import { Episode } from "../../shared/types/Episode";

import { useAuth } from "../../shared/context/TokenContext";
import '../css/ModalEpisodeEdifice.css';

interface ModalEpisodeEdificeProps {
  episode: Episode | null;
  idSerie: number | null;
  open: boolean;
  onCancel: () => void;
}

const ModalEpisodeEdifice: FunctionComponent<ModalEpisodeEdificeProps> = (
  props: ModalEpisodeEdificeProps
) => {
  const navigation = useNavigate();
  const { user } = useAuth()

  const { episode, idSerie, open, onCancel } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [isUnlocked, setIsUnlocked] = useState(false);

  const [code, setCode] = useState("");

  useEffect(() => {
    const loadStudentCode = async () => {
      const res = await getStudentCode();
      if (res.code) setCode(res.code);
    };
    loadStudentCode();
  }, []);

  const openEpisode = () => {
    if (episode)
      window.open(`https://webapp.nabook.co/reader/${episode.id}/${
            episode.origStartingNode
              ? episode.origStartingNode
              : episode.startingNode
          }?session_token=${user}`, '_blank');
    // if (episode)
    //   navigation(
    //     `/reader/${episode.id}/${
    //       episode.origStartingNode
    //         ? episode.origStartingNode
    //         : episode.startingNode
    //     }`,
    //     {
    //       state: {
    //         idSerie: idSerie,
    //         episode: episode,
    //         params: { isDys: false, fontSize: 1 },
    //       },
    //     }
    //   );
  };

  useEffect(() => {
    const isAssign = async () => {
      setIsLoading(true);
      if (episode) {
        const res = await getAssignTo(episode?.id);
        setIsUnlocked(res.isUnlocked);
      }
      setIsLoading(false);
    };

    isAssign();
  }, [episode]);

  const contentIfUnlock = () => {
    return (
      <>
        <div className="title" style={{ color: "black" }}>
          Vous allez accéder à la version web de Nabook.
        </div>
        <div className="resume" style={{ color: "black", marginTop: 12 }}>
          Pour une meilleure expérience de lecture, installez l’application
          mobile Nabook. Connectez-vous avec le code élève de votre enfant pour
          retrouver les lectures demandées par son enseignant.
        </div>
        <div
          className="serie-title"
          style={{
            color: "black",
            marginTop: 12,
            fontSize: 30,
            textAlign: "center",
          }}
        >
          {code}
        </div>
        <Flex
          style={{
            marginTop: 24,
            marginBottom: 24,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <QRCode
            value={
              "https://nabook.onelink.me/d3QQ/3ptadrfm?af_force_deeplink=true"
            }
            bgColor="white"
            color="#120D35"
            style={{
              border: "2px solid #120D35",
            }}
          />
        </Flex>
      </>
    );
  };

  const contentIfLock = () => {
    return (
      <>
        <div className="title" style={{ color: "black" }}>
          Episode non distribué
        </div>
        <div className="resume" style={{ color: "black", marginTop: 12 }}>
          Votre enseignant n’a pas distribué cet épisode. Pour le lire gratuitement, rendez-vous sur l’application mobile Nabook et connectez-vous avec votre code élève à la première ouverture.
        </div>
        <div
          className="serie-title"
          style={{
            color: "black",
            marginTop: 12,
            fontSize: 30,
            textAlign: "center",
          }}
        >
          {code}
        </div>
        <Flex
          style={{
            marginTop: 24,
            marginBottom: 24,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <QRCode
            value={
              "https://nabook.onelink.me/d3QQ/3ptadrfm?af_force_deeplink=true"
            }
            bgColor="white"
            color="#120D35"
            style={{
              border: "2px solid #120D35",
            }}
          />
        </Flex>
      </>
    );
  };

  return (
    <Modal
      open={open}
      title={<div style={{ minHeight: 20, maxHeight: 20 }}></div>}
      onCancel={() => {
        onCancel();
      }}
      footer={[
        <Flex key={"footer-1"} justify="center" align="center" gap={24}>
          <Flex
            className="btn-open-app"
            onClick={() => {
              window.open(
                "https://nabook.onelink.me/d3QQ/3ptadrfm?af_force_deeplink=true"
              );
            }}
            style={{ flex: 1, cursor: "pointer" }}
          >
            <div
              style={{
                width: "100%",
                background: "#FF6501",
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                padding: 10,
              }}
            >
              <div
                style={{
                  color: "white",
                  fontSize: 14,
                  fontFamily: "Roboto",
                  fontWeight: "normal",
                  wordWrap: "break-word",
                  textAlign: "center",
                }}
              >
                Ouvrir l'application mobile
              </div>
            </div>
          </Flex>
          {isUnlocked ? (
            <Flex
              onClick={() => {
                openEpisode();
              }}
              style={{ flex: 1, cursor: "pointer" }}
            >
              <div
                style={{
                  width: "100%",
                  background: "#FF6501",
                  borderRadius: 8,
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                }}
              >
                <div
                  style={{
                    color: "white",
                    fontSize: 14,
                    fontFamily: "Roboto",
                    fontWeight: "normal",
                    wordWrap: "break-word",
                    textAlign: "center",
                  }}
                >
                  Continuer sur le web
                </div>
              </div>
            </Flex>
          ) : null}
        </Flex>,
      ]}
    >
      {isLoading ? (
        <CircularProgress style={{ color: "black" }} />
      ) : isUnlocked ? (
        contentIfUnlock()
      ) : (
        contentIfLock()
      )}
    </Modal>
  );
};

export default ModalEpisodeEdifice;
